import { z } from "zod";

/**
 * AvaliacaoHabilidadeItemSchema
 */

export const AvaliacaoHabilidadeItemSchema = z.object({
  idHabilidadeItem: z.coerce.number(),
  idHabilidade: z.coerce.number(),
  habilidade: z.string().nullable().default(null),
  notaSelecionada: z.coerce.number().nullable().default(null),
  nota: z.coerce.number().nullable().default(null),
});

/**
 * AvaliacaoHabilidadeSchema
 */

export const AvaliacaoHabilidadeSchema = z.object({
  descricao: z.string().default(""),
  data: z.coerce.date({
    errorMap: (issue, { defaultError }) => ({
      message: issue.code === "invalid_date" ? "Este campo precisa ser preenchido com uma data valida!" : defaultError,
    }),
  }),
  idAvaliadoPor: z.coerce.number({ invalid_type_error: "Este campo deve ser preenchido!" }),
  dataReavaliacao: z.coerce.date().nullable().default(null),
  observacao: z.string().default(""),
  habilidadeItems: z.array(AvaliacaoHabilidadeItemSchema),
});

/**
 * AvaliacaoHabilidadeSchema
 */

export type AvaliacaoHabilidadeForm = z.infer<typeof AvaliacaoHabilidadeSchema>;

/**
 * AvaliacaoHabilidadeItemSchema
 */

export type AvaliacaoHabilidadeItemForm = z.infer<typeof AvaliacaoHabilidadeItemSchema>;